import { FileWithPath } from "@mantine/dropzone";
import { uploadFile } from "../../utils/upload";

export const transformImageValues = async (array: (string | FileWithPath)[], directory?: string, prefix?: string): Promise<string[]> => {
    const result: string[] = [];
    for (const item of array) {
        if (typeof item === 'string') {
            result.push(item);
        } else {
            const url = await uploadFile(item, directory, prefix);
            if (url) {
                result.push(url)
            }
        }
    }
    return result;
}